import create from "zustand"

export const useStore = create((set) => ({
    dragging: false,
    hovering: false,
    hoverData: {},
    transition: true,
    loaded: false,
    setLoaded: (l) => set(state => ({ ...state, loaded: l,  })),
    setTransition: (t) => set(state => ({ ...state, transition: t,  })),
    hover: (x, y, s) => set(state => ({ ...state, hovering: true, hoverData: {x, y, s} })),
    unhover: () => set(state => ({ ...state, hovering: false })),
    drag: (d) => set(state => ({ ...state, dragging: d,  })),
}))